export default __webpack_public_path__ + "static/media/howtouse_plus_04_ko.5b9e5c5b.png";